import _, { startCase } from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ReportsMonitoringContainer from '../../containers/reports/Monitoring';
import clsx from 'classnames';
import { regionToDisplay, regions } from '../../libs/regions';

import Button from '@material-ui/core/Button';

import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import InfoIcon from '@material-ui/icons/Info';
import LaunchIcon from '@material-ui/icons/Launch';
import ArrowBack from '@material-ui/icons/ArrowBackIos';

import { DatePicker } from '@material-ui/pickers';

import downloadCsvSvg from '../../images/icons/downloadCsv.svg';

//- material-ui
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { getSharedStyles } from '../../themes';
//import FMPHeadline from "../../components/ui/FMPHeadline";
import FMPRegionHeader from '../../components/ui/FMPRegionHeader';

import {
	ComposedChart,
	BarChart,
	Bar,
	Cell,
	Legend,
	ResponsiveContainer,
	XAxis,
	YAxis,
	Line,
	CartesianGrid,
	ReferenceLine,
	ReferenceArea,
	Treemap,
	Tooltip,
} from 'recharts';
import UpIcon from '@material-ui/icons/ArrowDropUp';
import DownIcon from '@material-ui/icons/ArrowDropDown';
import { Link, withRouter } from 'react-router-dom';
import { CircularProgress } from '@material-ui/core';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';

//- Federal holidays on their actual date. Keep in sync with SPECIAL_EVENTS in libs/reporting/forecastSpecialEvents.js in the backend repo
const SPECIAL_EVENTS = {
	'2024-11-11': 'Veterans Day',
	'2024-11-28': 'Thanksgiving Day',
	'2024-12-25': 'Christmas Day',
	'2025-01-01': "New Year's Day",
	'2025-01-20': 'Birthday of Martin Luther King, Jr.',
	'2025-02-17': "Washington's Birthday",
	'2025-05-26': 'Memorial Day',
	'2025-06-19': 'Juneteenth National Independence Day',
	'2025-07-04': 'Independence Day',
	'2025-09-01': 'Labor Day',
	'2025-10-13': 'Columbus Day',
	'2025-11-11': 'Veterans Day',
	'2025-11-27': 'Thanksgiving Day',
	'2025-12-25': 'Christmas Day',
	'2026-01-01': "New Year's Day",
	'2026-01-19': 'Birthday of Martin Luther King, Jr.',
	'2026-02-16': "Washington's Birthday",
	'2026-05-25': 'Memorial Day',
	'2026-06-19': 'Juneteenth National Independence Day',
	'2026-07-04': 'Independence Day',
	'2026-09-07': 'Labor Day',
	'2026-10-12': 'Columbus Day',
	'2026-11-11': 'Veterans Day',
	'2026-11-26': 'Thanksgiving Day',
	'2026-12-25': 'Christmas Day',
	'2027-01-01': "New Year's Day",
	'2027-01-18': 'Birthday of Martin Luther King, Jr.',
	'2027-02-15': "Washington's Birthday",
	'2027-05-31': 'Memorial Day',
	'2027-06-19': 'Juneteenth National Independence Day',
	'2027-07-04': 'Independence Day',
	'2027-09-06': 'Labor Day',
	'2027-10-11': 'Columbus Day',
	'2027-11-11': 'Veterans Day',
	'2027-11-25': 'Thanksgiving Day',
	'2027-12-25': 'Christmas Day',
};

const numberSort = {
	r: 10,
	g: 20,
	o: 30,
};

const styles = (theme) => ({
	...getSharedStyles(theme),
	label: {
		color: '#555',
	},
	subLabel: {
		fontSize: 13,
		color: '#777',
	},
	value: {
		//fontWeight: 600,
	},
	statTable: {
		border: `1px solid #ddd`,
		padding: 20,
		tableLayout: 'auto',
		backgroundColor: 'white',
		width: '100%',
	},
	stationBreakdownTable: {
		padding: 20,
		tableLayout: 'auto',
		backgroundColor: 'white',
		//width: '100%',
		borderCollapse: 'collapse',
	},
	analysisContainer: {
		//border : `1px solid #ddd`,
		//padding : 20,
	},
	row: {
		margin: 0,
		backgroundColor: '#fff',
		fontsize: 16,
	},
	evenRow: {
		backgroundColor: '#eee',
	},
	td: {
		padding: 15,
		whiteSpace: 'nowrap',
	},
	stationNameCell: {
		padding: 5,
		whiteSpace: 'nowrap',
	},
	stationReasonCell: {
		padding: 5,
	},
	stationPercentageCell: {
		padding: 5,
		whiteSpace: 'nowrap',
		fontSize: 14,
		width: 50,
	},
	upDownIcon: {
		marginTop: -15,
		bottom: -6,
		width: 28,
		height: 22,
		position: 'relative',
	},
	diffUp: {
		fontWeight: 900,
		color: '#4CAF50',
	},
	diffDown: {
		fontWeight: 900,
		color: '#FF500F',
	},
	chartTitle: {
		fontSize: 18,
	},
	bestFitStats: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: 10,
		padding: '15px 0px',
	},
	bestFitStat: {
		border: '1px solid #ddd',
		borderRadius: 4,
		padding: '8px 12px',
		minWidth: 130,
		backgroundColor: 'white',
	},
	bestFitStatLabel: {
		fontSize: 12,
		color: '#777',
	},
	bestFitStatValue: {
		fontSize: 20,
		fontWeight: 500,
		color: '#333',
	},
	bestFitStatSubLabel: {
		fontSize: 11,
		color: '#999',
	},
	bestFitTooltip: {
		backgroundColor: 'white',
		border: '1px solid #ccc',
		padding: '8px 12px',
		fontSize: 13,
		lineHeight: '20px',
	},
	bestFitTooltipTitle: {
		fontWeight: 600,
		paddingBottom: 3,
	},
	bestFitTooltipNote: {
		color: '#777',
		fontStyle: 'italic',
	},
	bestFitExplain: {
		color: '#555',
		fontSize: 14,
		lineHeight: '22px',
		paddingTop: 10,
		'& > div': {
			paddingBottom: 4,
		},
	},
	analysisHeadline: {
		fontSize: 18,
		textTransform: 'uppercase',
		fontWeight: 600,
		color: '#666',
		paddingBottom: 5,
		paddingTop: 15,
	},
	analysisTitle: {
		fontWeight: 600,
		fontSize: 17,
		color: '#555',
		paddingBottom: 5,
		paddingTop: 20,
	},
	howCalculated: {
		fontSize: 16,
		color: '#777',
		paddingBottom: 5,
		paddingTop: 20,
		display: 'flex',
		alignItems: 'center',
	},
	colLabel: {
		color: `#555`,
		fontSize: 12,
		fontWeight: 500,
		paddingLeft: 2,
	},
	colSubLabel: {
		color: `#777`,
		fontSize: 11,
		fontWeight: 300,
	},
	regionLink: {
		textDecoration: 'none',
		color: '#0790CB',
	},
	backLink: {
		color: '#0790CB',
		textDecoration: 'none',
		fontSize: 18,
		padding: '10px 0px',
		display: 'flex',
		alignItems: 'center',
	},
	innerLink: {
		display: 'flex',
		alignItems: 'center',
		fontWeight: 400,
	},
	headlinePrefix: {
		textAlign: 'left',
		textTransform: 'uppercase',
		letterSpacing: 1,
		fontFamily: `Roboto,sans-serif`,
		color: '#999',
		fontWeight: 500,
		fontSize: 20,
	},
	customHeadline: {
		display: 'flex',
		margin: '50px 0px 10px 0px',
		marginTop: 10,
		textAlign: 'left',
		textTransform: 'uppercase',
		letterSpacing: 1,
		fontFamily: `Roboto,sans-serif`,
		color: '#999',
		fontWeight: 100,
		fontSize: 28,
		[theme.breakpoints.up('md')]: {
			fontSize: 40,
		},
		borderBottom: '1px solid #eee',
		paddingBottom: 15,
	},
	workingDate: {
		//padding: '5px 5px',
		border: '1px solid transparent',
		borderBottom: '1px solid #bbb',
		borderRadius: '2px',
		cursor: 'pointer',
		transition: '0.3s',
		'&:hover': {
			border: '1px solid #aaa',
			backgroundColor: `#f5f5f5`,
		},
	},
	info: {
		color: '#2196F3',
		width: 16,
		height: 16,
		paddingRight: 3,
	},
	downloadCsvIcon: {
		display: 'inline-block',
		width: 40,
		height: 40,
		backgroundImage: `url('${downloadCsvSvg}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		position: 'relative',
		flexShrink: 0,
		cursor: 'pointer',
	},
});

//const COLORS = ['#8889DD', '#9597E4', '#8DC77B', '#A5D297', '#E2CF45', '#F8C12D'];

const programToDisplay = {
	inRebateProgram: 'In Rebate Program',
	notInRebateProgram: 'Not In Rebate Program (Non G&M)',
	notInRebateProgramGm: 'Not In Rebate Program (G&M)',
};

const customerToDisplay = {
	allSites: 'All',
	pearsonRetail: 'Pearson Retail',
	gm: 'G&M',
	hs: 'H&S',
};
const customerToSortPriority = {
	allSites: '100',
	pearsonRetail: '200',
	gm: '300',
	hs: '400',
};

class CustomizedTreeMapContent extends Component {
	render() {
		const { depth, x, y, width, height, children, name } = this.props;

		let stationFontSize = 14;
		let galFontSize = 12;
		let stationY = y + height / 2 + 8;
		let galLabel = '';
		let stationWritingMode = '';

		let fill = 'none';
		let gallonDiff = '';
		if (depth === 1) {
			const child = _.first(children);
			const { totalVolumePercentageChangeOverLastMonth, diff } = child;
			fill = pToC(totalVolumePercentageChangeOverLastMonth);
			gallonDiff = diff;

			if (width <= 34) {
				stationWritingMode = 'vertical-rl';

				stationFontSize = 9;
				galFontSize = 7;
				stationY = y + height / 2 + 9;
				galLabel = `${gallonDiff}`;
			} else if (height <= 28 || width <= 40) {
				stationFontSize = 11;
				galFontSize = 9;
				stationY = y + height / 2 + 9;
				galLabel = `${gallonDiff}`;
			} else if (height <= 32 || width <= 47) {
				stationFontSize = 13;
				galFontSize = 11;
				stationY = y + height / 2 + 9;
				galLabel = `${gallonDiff}`;
			} else {
				galLabel = `${gallonDiff} gal`;
			}
		}

		return (
			<g>
				<rect
					x={x}
					y={y}
					width={width}
					height={height}
					style={{
						//fill: depth < 2 ? colors[Math.floor(index / root.children.length * 6)] : 'none',
						fill,
						stroke: '#fff',
						strokeWidth: 2 / (depth + 1e-10),
						strokeOpacity: 1 / (depth + 1e-10),
					}}
				/>
				{depth === 1 ? (
					<text
						x={x + width / 2}
						y={stationY}
						textAnchor="middle"
						fill="#111"
						stroke="none"
						fontSize={stationFontSize}
						writingMode={stationWritingMode}
					>
						{name}
					</text>
				) : null}
				{depth === 1 ? (
					<text
						x={x + 4}
						y={y + 12}
						fill="#333"
						fontSize={galFontSize}
						fillOpacity={0.9}
						stroke="none"
					>
						{galLabel}
					</text>
				) : null}
			</g>
		);
	}
}

//const {root, depth, x, y, width, height, index, payload, colors, rank, name} = this.props;

CustomizedTreeMapContent.propTypes = {
	root: PropTypes.object,
	depth: PropTypes.number,
	x: PropTypes.number,
	y: PropTypes.number,
	width: PropTypes.number,
	height: PropTypes.number,
	index: PropTypes.number,
	payload: PropTypes.object,
	colors: PropTypes.array,
	rank: PropTypes.number,
	name: PropTypes.string,
	children: PropTypes.array,
};

function makePercentage(p, d = 2) {
	return _.round((p - 1) * 100, d);
}
function formatPercentage(p, d = 2) {
	if (_.isNil(p)) {
		return 'n/a';
	}

	if (p === '-') {
		return '-';
	}
	return makePercentage(p, d) + '%';
}

function formatSigned(value, suffix, d = 2) {
	if (!_.isFinite(value)) {
		return 'n/a';
	}
	const rounded = _.round(value, d);
	return (rounded > 0 ? '+' : '') + rounded + suffix;
}

//- p is a ratio like 1.033 (same as makePercentage)
function formatSignedPercentage(p, d = 1) {
	return formatSigned(makePercentage(p, d), '%', d);
}

function formatGallons(g) {
	if (_.isNil(g)) {
		return 'n/a';
	}
	return parseInt(g, 10).toLocaleString() + ' gal';
}

const percentageToColor = {};
let r = 255;
let g = 255;
let b = 255;

// rgb(245, 249, 246) 1%

_.range(0, 41).forEach((i) => {
	percentageToColor[i] = { r, g, b };
	r -= 4.5;
	g -= 2.5;
	b -= 3.5;
});

r = 255;
g = 255;
b = 255;

_.range(0, 41).forEach((i) => {
	percentageToColor[-i] = { r: _.round(r), g, b };
	r -= 0.25;
	g -= 2.5;
	b -= 2.5;
});

//rgb(250, 229, 231) //13
//rgb(250, 227, 229) //14
//rgb(249, 225, 227) //15
function pToC(p) {
	let v = _.round(makePercentage(p));
	let r, g, b;
	if (v >= 40) {
		({ r, g, b } = percentageToColor[40]);
	} else if (v <= -40) {
		({ r, g, b } = percentageToColor[-40]);
	} else {
		({ r, g, b } = percentageToColor[v] || percentageToColor[0]);
	}
	return `rgb(${r}, ${g}, ${b})`;
}

class FuelForecast extends Component {
	constructor(props) {
		super(props);
		const specialEvents = _.get(this.props, ['match', 'params', 'specialEvents']);
		const customerFromUrl = _.get(this.props, ['match', 'params', 'customer']);
		const regionFromUrl = _.get(this.props, ['match', 'params', 'region']);
		const includeSpecialEvents = specialEvents === 'includeSpecialEvents';

		this.state = {
			isFetching: true,
			customerFromUrl,
			regionFromUrl,
			suggestedWorkingDate: undefined,
			isWorkingDateOpen: false,
			regionFilter: undefined,
			includeSpecialEvents,
			specialEventsPrefix: includeSpecialEvents ? 'includeSpecialEvents' : 'excludeSpecialEvents',
		};
	}

	componentDidMount() {
		const { getSlidingMonthComparison, slidingMonthComparisonResult } = this.props;
		if (!slidingMonthComparisonResult) {
			const { suggestedWorkingDate, includeSpecialEvents } = this.state;
			getSlidingMonthComparison({
				params: {
					workingDate: suggestedWorkingDate,
					includeSpecialEvents,
				},
				callback: () => {
					this.setState({ isFetching: false });
				},
			});
		} else {
			this.setState({ isFetching: false });
		}
	}

	componentDidUpdate(prevProps) {
		const customerFromUrl = _.get(this.props, ['match', 'params', 'customer']);
		const regionFromUrl = _.get(this.props, ['match', 'params', 'region']);
		if (
			regionFromUrl !== prevProps.match.params.region ||
			customerFromUrl !== prevProps.match.params.customer
		) {
			this.setState({ regionFromUrl, customerFromUrl });
		}

		if (this.props.location !== prevProps.location) {
			window.scrollTo(0, 0);
		}
	}

	setWorkingDate = (date) => {
		const suggestedWorkingDate = moment(date).format('YYYY-MM-DD');
		this.setState({
			suggestedWorkingDate,
			isFetching: true,
		});

		const { getSlidingMonthComparison } = this.props;
		const { includeSpecialEvents } = this.state;
		getSlidingMonthComparison({
			params: {
				workingDate: suggestedWorkingDate,
				includeSpecialEvents,
			},
			callback: () => {
				this.setState({ isFetching: false });
			},
		});
	};

	setWorkingDateOpen = (isWorkingDateOpen) => {
		this.setState({ isWorkingDateOpen });
	};

	handlePureChange = (value, path) => {
		const arrayPath = _.toPath(path);
		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, arrayPath.slice(1), value);
			newState[basePath] = base;
		} else {
			newState[basePath] = value;
		}

		this.setState(newState);
	};

	render() {
		const {
			classes,
			slidingMonthComparisonResult,
			//authUser
		} = this.props;

		if (!slidingMonthComparisonResult || this.state.isFetching) {
			return (
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<Paper className={classes.paper} style={{ padding: 30 }}>
							<CircularProgress />
							<span style={{ fontSize: 20, color: '#999', fontStyle: 'italics', paddingLeft: 10 }}>
								Fetching and calculating stats...
							</span>
						</Paper>
					</Grid>
				</Grid>
			);
		}

		const { customerFromUrl, regionFromUrl } = this.state;

		let {
			workingDate,
			workingMonthHasEnoughDays,
			numberOfDaysNeededForPredictions,

			totalStations,
			totalGoodStations,

			volumeMeanPercentageChangeOverLastMonth,
			totalVolumePercentageChangeOverLastMonthByDate,
			totalVolumeFinalPrediction,
			volumeBestFit,

			finalMeanPercentages = [],
			programStats,
			customerStats,
			stationTankResults,

			collections,
			stationTankList,

			workingTotalVolume,
			lastMonthTotalAvgVolume,
		} = slidingMonthComparisonResult;

		const { stationCollection } = collections;
		const stationMap = _.keyBy(stationCollection, 'stationId');

		if (customerFromUrl) {
			// This COULD be rebate program
			let stats = undefined;
			const rebateStats = _.find(programStats, { program: customerFromUrl });

			if (rebateStats) {
				stats = rebateStats;
			} else {
				const customerStat = _.find(customerStats, { customer: customerFromUrl });
				if (!customerStat) {
					return <div>Missing key ({customerFromUrl}) in stat list. Check the URL?</div>;
				}

				if (!regionFromUrl) {
					return <div>Missing region in URL. Check the URL?</div>;
				}
				const regionStats = _.find(customerStat.regions, { region: regionFromUrl });
				if (!regionStats) {
					return (
						<div>
							Missing region ({regionFromUrl}) in list for customer: {customerFromUrl}. Check the
							URL?
						</div>
					);
				}
				stats = regionStats;
			}

			({
				workingDate,
				totalStations,
				totalGoodStations,

				volumeMeanPercentageChangeOverLastMonth,
				totalVolumePercentageChangeOverLastMonthByDate,
				totalVolumeFinalPrediction,
				volumeBestFit,

				finalMeanPercentages = [],
				stationTankList,

				workingTotalVolume,
				lastMonthTotalAvgVolume,
			} = stats);
		}

		const stationTankResultMap = {};
		stationTankResults.forEach((stationTank) => {
			const { stationId, tankNumber } = stationTank;
			stationTankResultMap[`${stationId}_${tankNumber}`] = stationTank;
		});

		//- Look up station and sort
		const stationTankStats = [];
		stationTankList.forEach(({ stationId, tankNumber }) => {
			const station = stationMap[stationId] || { number: '?', name: 'Missing' };
			const stationTankStat = stationTankResultMap[`${stationId}_${tankNumber}`];

			const { number } = station;
			let sortBy = '99';
			if (number) {
				const firstChar = number.toLowerCase().charAt(0);
				sortBy = (numberSort[firstChar] || 98) + '_' + number + '_' + tankNumber;
			}

			stationTankStat.station = station;
			stationTankStat.stationSortBy = sortBy;
			stationTankStats.push(stationTankStat);
		});

		if (!workingMonthHasEnoughDays) {
			//finalPrediction = '-';
			//finalPredictionWithStdRemoved = '-';
			totalVolumeFinalPrediction = '-';
		}

		const overallStats = [
			{
				label: `Total stations used for forecast`,
				value: `${totalGoodStations} out of ${totalStations}`,
			},
			{
				label: `Current percentage change this month over last month`,
				value: formatPercentage(volumeMeanPercentageChangeOverLastMonth),
				...this.getUpDown(volumeMeanPercentageChangeOverLastMonth),
			},
			{
				label: `Predicted percentage change this month over last month`,
				value: formatPercentage(totalVolumeFinalPrediction),
				...this.getUpDown(totalVolumeFinalPrediction),
			},
			{
				label: `Volume this month`,
				value: formatGallons(workingTotalVolume),
			},
			{
				label: `Volume last month (same period using day of the week averages)`,
				value: formatGallons(lastMonthTotalAvgVolume),
			},
		];

		const programStatRows = [];
		programStats.forEach((programStat) => {
			const { program, totalStations, totalGoodStations } = programStat;
			const programDisplay = programToDisplay[program]
				? programToDisplay[program]
				: _.startCase(program);

			let { totalVolumeFinalPrediction } = programStat;
			if (!workingMonthHasEnoughDays) {
				totalVolumeFinalPrediction = '-';
			}

			programStatRows.push({
				program,
				label: `${programDisplay} overall average`,
				subLabel: `${totalGoodStations} out of ${totalStations}`,
				values: [
					{
						value: formatPercentage(programStat.volumeMeanPercentageChangeOverLastMonth),
						...this.getUpDown(programStat.volumeMeanPercentageChangeOverLastMonth),
					},
					{
						value: formatPercentage(totalVolumeFinalPrediction),
						...this.getUpDown(totalVolumeFinalPrediction),
					},
					{
						value: formatGallons(programStat.workingTotalVolume),
					},
					{
						value: formatGallons(programStat.lastMonthTotalAvgVolume),
					},
				],
			});
		});

		let customerRows = [];
		customerStats.forEach((customerStat) => {
			//const { customer, totalStations, totalGoodStations } = customerStat;
			const { customer, regions } = customerStat;
			const customerDisplay = customerToDisplay[customer]
				? customerToDisplay[customer]
				: _.startCase(customer);

			const customerRow = {
				customer,
				customerDisplay,
				sortPriority: customerToSortPriority[customer],
				regionRows: [],
			};

			regions.forEach((regionStat) => {
				const { region, totalStations, totalGoodStations } = regionStat;
				const regionDisplay = regionToDisplay(region);

				let { totalVolumeFinalPrediction } = regionStat;
				if (!workingMonthHasEnoughDays) {
					totalVolumeFinalPrediction = '-';
				}

				customerRow.regionRows.push({
					region,
					label: `${regionDisplay} (${customerDisplay}) overall average`,
					subLabel: `${totalGoodStations} out of ${totalStations}`,
					values: [
						{
							value: formatPercentage(regionStat.volumeMeanPercentageChangeOverLastMonth),
							...this.getUpDown(regionStat.volumeMeanPercentageChangeOverLastMonth),
						},
						{
							value: formatPercentage(totalVolumeFinalPrediction),
							...this.getUpDown(totalVolumeFinalPrediction),
						},
						{
							value: formatGallons(regionStat.workingTotalVolume),
						},
						{
							value: formatGallons(regionStat.lastMonthTotalAvgVolume),
						},
					],
				});
			});
			customerRow.regionRows = _.sortBy(customerRow.regionRows, 'region');
			customerRows.push(customerRow);
		});

		customerRows = _.sortBy(customerRows, 'sortPriority');

		let dataForDomChart = [];
		_.keys(totalVolumePercentageChangeOverLastMonthByDate)
			.sort()
			.forEach((dateKey) => {
				const decimalChange = totalVolumePercentageChangeOverLastMonthByDate[dateKey];
				const percentageChange = makePercentage(decimalChange);

				let name = moment(dateKey).format('M/D');
				if (SPECIAL_EVENTS[dateKey]) {
					name += ` (${SPECIAL_EVENTS[dateKey]})`;
				}

				dataForDomChart.push({
					name,
					percentageChange,
				});
			});

		/*
		let dataForDomChartWithStdRemoved = [];
		(_.keys(meanPercentageChangeOverLastMonthByDateWithStdRemoved)).sort().forEach(dateKey => {
			const decimalChange = meanPercentageChangeOverLastMonthByDateWithStdRemoved[dateKey];
			const percentageChange = makePercentage(decimalChange);

			dataForDomChartWithStdRemoved.push({
				name : moment(dateKey).format('M/D'),
				percentageChange,
			});
		});
		*/

		//const { stationId, tankNumber, changeByDate, isInvalid, meanPercentageChangeOverLastMonth } = stationTankResult;

		const dataForBestFitChart = finalMeanPercentages.map((data) => {
			const {
				dateKey,
				volumeMeanPercentageChangeOverLastMonth,
				volumeBestFitPoint,
				isPrediction,
				workingTotalVolume,
				lastMonthTotalAvgVolumeOnThisDow,
			} = data;

			return {
				name: moment(dateKey).format('M/D'),
				dateKey,
				percentageChange: makePercentage(volumeMeanPercentageChangeOverLastMonth),
				bestFitPoint: _.isFinite(volumeBestFitPoint) ? makePercentage(volumeBestFitPoint) : null,
				isPrediction,
				workingTotalVolume,
				lastMonthTotalAvgVolumeOnThisDow,
			};
		});

		const { isWorkingDateOpen, suggestedWorkingDate } = this.state;
		const workingDateFormatted = moment(workingDate).format('dddd, MMMM Do, YYYY');
		let prefix = 'Fuel Forecast';
		if (regionFromUrl) {
			let regionPrefix = startCase(regionFromUrl);
			let customerPrefix = startCase(customerFromUrl);

			if (regionToDisplay[regionFromUrl]) {
				regionPrefix = regionToDisplay[regionFromUrl];
			}

			if (programToDisplay[customerFromUrl]) {
				customerPrefix = programToDisplay[customerFromUrl];
			} else if (customerToDisplay[customerFromUrl]) {
				customerPrefix = customerToDisplay[customerFromUrl];
			}
			prefix += ` for ${customerPrefix} ${regionPrefix}`;
		}
		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Paper className={classes.paper}>
						<Grid container spacing={3}>
							<Grid item xs={12} md={12}>
								<div className={classes.headlinePrefix}>{prefix}</div>
								<div className={classes.customHeadline}>
									<div style={{ fontWeight: 600 }}>Range: </div>
									<div>
										<div
											className={classes.workingDate}
											onClick={() => this.setWorkingDateOpen(true)}
										>
											{workingDateFormatted}
										</div>
										<div style={{ display: 'none' }}>
											<DatePicker
												open={isWorkingDateOpen}
												onOpen={() => this.setWorkingDateOpen(true)}
												onClose={() => this.setWorkingDateOpen(false)}
												label={''}
												value={suggestedWorkingDate || null}
												onChange={this.setWorkingDate}
												showTodayButton
												animateYearScrolling
												format={'D, MMM'}
											/>
										</div>
									</div>
								</div>
							</Grid>
						</Grid>

						{!workingMonthHasEnoughDays && (
							<Grid container spacing={3} style={{ fontSize: 18 }}>
								<Grid item xs={12} md={12}>
									<div>
										<InfoIcon className={classes.info} /> Not giving projections because there have
										not been {numberOfDaysNeededForPredictions} days yet during this working period.
									</div>
								</Grid>
							</Grid>
						)}

						<Grid container spacing={3}>
							<Grid item xs={12} md={12}>
								<Grid container spacing={3}>
									<Grid item xs={12} md={8}>
										{this.renderSpecialEventsSection()}

										{!regionFromUrl && <div className={classes.analysisHeadline}>Overall</div>}
										{regionFromUrl && (
											<Link to={`/reports/fuelForecast`} className={classes.backLink}>
												<ArrowBack style={{ paddingLeft: 5 }} /> Back to overall
											</Link>
										)}
										<table className={classes.statTable}>
											<tbody>{this.drawOverallStats({ overallStats })}</tbody>
										</table>
									</Grid>
								</Grid>
							</Grid>

							<Grid item xs={12} md={12}>
								{this.renderFilterOptions()}
								<Grid container spacing={3}>
									{this.drawCustomerTables({ customerRows })}
								</Grid>
							</Grid>

							<Grid item xs={12} md={12}>
								<Grid container spacing={3}>
									{this.drawProgramStats({ programStatRows })}
								</Grid>
							</Grid>

							<Grid item xs={12} md={12}>
								{this.renderHowCalculated()}
							</Grid>
						</Grid>
					</Paper>
				</Grid>
				<Grid item xs={12}>
					<Paper className={classes.paper}>
						<FMPRegionHeader isTop={true} label={`${prefix} % Changes by Date`} />

						<div style={{ padding: 20 }}>
							<div className={classes.chartTitle}>Percentage Change over Last Month</div>
							{this.drawChangeOverLastMonth({
								dataForChart: dataForDomChart,
								refLineValue: volumeMeanPercentageChangeOverLastMonth,
							})}
						</div>

						<div style={{ padding: 20 }}>
							<div className={classes.chartTitle}>
								Best Fit Trend Line (how the prediction is calculated)
							</div>

							{!workingMonthHasEnoughDays && (
								<div style={{ color: '#777', padding: 15 }}>
									Not enough days yet for a best fit line
								</div>
							)}

							{workingMonthHasEnoughDays && !volumeBestFit && (
								<div style={{ color: '#777', padding: 15 }}>
									Best fit line is not available for this selection
								</div>
							)}

							{workingMonthHasEnoughDays &&
								volumeBestFit &&
								this.drawBestFitChart({
									dataForChart: dataForBestFitChart,
									volumeBestFit,
									monthAverage: totalVolumeFinalPrediction,
									workingDate,
									totalGoodStations,
									totalStations,
								})}
						</div>
					</Paper>
				</Grid>

				{!regionFromUrl && this.renderProgramComparison({ programStats })}

				<Grid item xs={12}>
					<Accordion
						onChange={(event, isExpanded) => {
							this.setState({ isDetailedExpanded: isExpanded });
						}}
						expanded={this.state.isDetailedExpanded}
					>
						<AccordionSummary
							expandIcon={<ExpandMoreIcon />}
							aria-controls="panel1a-content"
							id="panel1a-header"
						>
							<div
								className={classes.howCalculated}
								style={{ fontSize: '22px', paddingTop: '10px' }}
							>
								<InfoIcon style={{ paddingRight: 5 }} /> Expand for Detailed Station Information
							</div>
						</AccordionSummary>

						{this.state.isDetailedExpanded && (
							<AccordionDetails>
								<Grid container spacing={3}>
									<Grid item xs={12}>
										<Paper className={classes.paper}>
											<FMPRegionHeader isTop={true} label={`Station by Station Breakdown`} />

											{this.renderStationBreakdown({ stationTankStats })}
										</Paper>
									</Grid>

									<Grid item xs={12}>
										<Paper className={classes.paper}>
											<FMPRegionHeader
												isTop={true}
												label={`Current Month Total Volume Difference over Last Month`}
											/>
											{this.renderStationTreeMap({ stationTankStats })}
										</Paper>
									</Grid>

									<Grid item xs={12}>
										<Paper className={classes.paper}>
											<FMPRegionHeader isTop={true} label={`Ignored Station Listing`} />
											{this.renderSkippedStations({ stationTankStats })}
										</Paper>
									</Grid>
								</Grid>
							</AccordionDetails>
						)}
					</Accordion>
				</Grid>
			</Grid>
		);
	}

	renderSpecialEventsSection = () => {
		const { classes, slidingMonthComparisonResult } = this.props;
		const { includeSpecialEvents } = this.state;
		//- Only the working month gets smoothed, so the working year's holidays are the ones that matter
		const workingYear = moment(slidingMonthComparisonResult.workingDate).format('YYYY');
		const specialEventDates = _.keys(SPECIAL_EVENTS).filter((date) =>
			date.startsWith(`${workingYear}-`)
		);
		return (
			<div className={classes.statTable} style={{ display: 'flex', marginRight: 20 }}>
				<div style={{ marginRight: 20 }}>
					{includeSpecialEvents ? (
						<div style={{ paddingRight: '10px', borderRight: '1px solid #eee' }}>
							<div style={{ fontSize: '105%', paddingBottom: '5px' }}>
								Currently <b>including</b> special events (holidays) in forecast.
							</div>

							<Link
								to={`/reports/fuelForecast/excludeSpecialEvents`}
								className={classes.regionLink}
								rel="noreferrer noopener"
								target="_blank"
							>
								<div className={clsx(classes.value, classes.innerLink)}>
									View Forecast excluding special events{' '}
									<LaunchIcon style={{ paddingLeft: 5, fontSize: 15 }} />
								</div>
							</Link>
						</div>
					) : (
						<div style={{ paddingRight: '10px', borderRight: '1px solid #eee' }}>
							<div style={{ fontSize: '105%', paddingBottom: '5px' }}>
								Currently <b>excluding</b> special events (holidays) in forecast.
							</div>
							<Link
								to={`/reports/fuelForecast/includeSpecialEvents`}
								className={classes.regionLink}
								rel="noreferrer noopener"
								target="_blank"
							>
								<div className={clsx(classes.value, classes.innerLink)}>
									View Forecast including special events{' '}
									<LaunchIcon style={{ paddingLeft: 5, fontSize: 15 }} />
								</div>
							</Link>
						</div>
					)}
				</div>
				<div style={{ fontSize: '85%' }}>
					<div>Special Event Dates ({workingYear})</div>
					<ul>
						{specialEventDates.map((date) => {
							return (
								<li key={date}>
									{moment(date).format('ddd, MMM Do, YYYY')} - {SPECIAL_EVENTS[date]}{' '}
								</li>
							);
						})}
					</ul>
				</div>
			</div>
		);
	};

	renderFilterOptions = () => {
		if (this.state.regionFromUrl) {
			return null;
		}

		return (
			<>
				<div>Quick Filter Region Options</div>
				<ToggleButtonGroup
					value={this.state.regionFilter}
					color="primary"
					exclusive
					size="small"
					aria-label="region filter"
					onChange={(event, newRegionFilter) => {
						console.log('newRegionFilter', newRegionFilter);
						this.setState({ regionFilter: newRegionFilter });
					}}
				>
					<ToggleButton key={'none'} value={undefined}>
						None
					</ToggleButton>
					{regions.map((region) => {
						return (
							<ToggleButton key={region.value} value={region.value}>
								{region.display}
							</ToggleButton>
						);
					})}
				</ToggleButtonGroup>
			</>
		);
	};

	renderProgramComparison = ({ programStats }) => {
		const { classes } = this.props;

		if (_.isEmpty(programStats)) {
			return;
		}

		const inRebate = programStats[0];
		const notInRebate = programStats[1];
		const notInRebateGm = programStats[2];
		let { totalVolumePercentageChangeOverLastMonthByDate } = inRebate;

		let dataForDomChart = [];
		_.keys(totalVolumePercentageChangeOverLastMonthByDate)
			.sort()
			.forEach((dateKey) => {
				const decimalChange = totalVolumePercentageChangeOverLastMonthByDate[dateKey];
				const percentageChange = makePercentage(decimalChange);

				const decimalChange2 = notInRebate.totalVolumePercentageChangeOverLastMonthByDate[dateKey];
				const percentageChange2 = makePercentage(decimalChange2);

				const decimalChange3 =
					notInRebateGm.totalVolumePercentageChangeOverLastMonthByDate[dateKey];
				const percentageChange3 = makePercentage(decimalChange3);

				dataForDomChart.push({
					name: moment(dateKey).format('M/D'),
					percentageChange,
					percentageChange2,
					percentageChange3,
				});
			});

		return (
			<Grid item xs={12}>
				<Paper className={classes.paper}>
					<FMPRegionHeader isTop={true} label={`Rebate vs Not Participating`} />
					{this.drawRebateComparison({
						dataForChart: dataForDomChart,
					})}
				</Paper>
			</Grid>
		);
	};

	drawOverallStats = ({ overallStats }) => {
		const { classes } = this.props;
		return (
			<>
				{overallStats.map((stat, i) => {
					const isOdd = i % 2;
					const { value, label, subLabel } = stat;
					return (
						<tr key={i} className={clsx(classes.row, !isOdd ? classes.evenRow : '')}>
							<td className={classes.td} style={{ textAlign: 'left' }}>
								<div className={classes.label}>{label}</div>
								{subLabel && <div className={classes.subLabel}>{subLabel}</div>}
							</td>
							<td className={clsx(classes.td, stat.diffClass)} style={{ textAlign: 'right' }}>
								{stat.diffIcon && stat.diffIcon}
								<span className={classes.value}>{value}</span>
							</td>
						</tr>
					);
				})}
			</>
		);
	};

	drawProgramStats = ({ programStatRows }) => {
		const { classes } = this.props;

		const { regionFromUrl, specialEventsPrefix } = this.state;
		if (regionFromUrl) {
			return null;
		}

		return (
			<Grid item xs={12} md={8}>
				<div className={classes.analysisHeadline}>Rebate Program vs Not Participating</div>
				<table className={classes.statTable}>
					<thead>
						<tr>
							<td className={classes.colLabel}>Program</td>
							<td className={classes.colLabel}>
								<div className={classes.colLabel}>Current % Change</div>
								<div className={classes.colSubLabel}>over last month</div>
							</td>
							<td className={classes.colLabel}>
								<div className={classes.colLabel}>Predicted % Change</div>
								<div className={classes.colSubLabel}>over last month</div>
							</td>
							<td className={classes.colLabel}>Current Month Volume</td>
							<td className={classes.colLabel}>Last Month Volume</td>
							<td>
								<div className={classes.colLabel}>Details</div>
							</td>
						</tr>
					</thead>
					<tbody>
						{programStatRows.map((stat, i) => {
							const isOdd = i % 2;
							const { values, label, subLabel, program } = stat;

							return (
								<tr key={i} className={clsx(classes.row, !isOdd ? classes.evenRow : '')}>
									<td className={classes.td} style={{ textAlign: 'left' }}>
										<div className={classes.label}>{label}</div>
										{subLabel && <div className={classes.subLabel}>{subLabel}</div>}
									</td>

									{values.map(({ diffIcon, diffClass, value }, i) => (
										<td
											key={i}
											className={clsx(classes.td, diffClass)}
											style={{ textAlign: 'right' }}
										>
											{diffIcon && diffIcon}
											<span className={classes.value}>{value}</span>
										</td>
									))}

									<td className={classes.td}>
										<Link
											to={`/reports/fuelForecast/${specialEventsPrefix}/${program}/allRegions`}
											className={classes.regionLink}
										>
											<div className={clsx(classes.value, classes.innerLink)}>
												View Details <LaunchIcon style={{ paddingLeft: 5, fontSize: 15 }} />
											</div>
										</Link>
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</Grid>
		);
	};

	drawCustomerTables = ({ customerRows }) => {
		const { classes } = this.props;

		const { regionFromUrl } = this.state;
		if (regionFromUrl) {
			return null;
		}

		return customerRows.map((customerRow) => {
			return (
				<Grid item xs={12} md={8} key={customerRow.customer}>
					<div className={classes.analysisHeadline}>
						{customerRow.customerDisplay} Sites by Region
					</div>
					{this.drawCustomerTable({ customerRow })}
				</Grid>
			);
		});
	};

	drawCustomerTable = ({ customerRow }) => {
		const { classes } = this.props;

		const { regionFromUrl, regionFilter, specialEventsPrefix } = this.state;
		if (regionFromUrl) {
			return null;
		}

		const { customer, regionRows } = customerRow;

		return (
			<table className={classes.statTable}>
				<thead>
					<tr>
						<td className={classes.colLabel}>Region</td>
						<td className={classes.colLabel}>
							<div className={classes.colLabel}>Current % Change</div>
							<div className={classes.colSubLabel}>over last month</div>
						</td>
						<td className={classes.colLabel}>
							<div className={classes.colLabel}>Predicted % Change</div>
							<div className={classes.colSubLabel}>over last month</div>
						</td>
						<td className={classes.colLabel}>Current Month Volume</td>
						<td className={classes.colLabel}>Last Month Volume</td>
						<td>
							<div className={classes.colLabel}>Details</div>
						</td>
					</tr>
				</thead>
				<tbody>
					{regionRows.map((regionStat, i) => {
						const isOdd = i % 2;
						const { values, label, subLabel, region } = regionStat;

						if (regionFilter && regionFilter !== region) {
							return null;
						}

						return (
							<tr key={i} className={clsx(classes.row, !isOdd ? classes.evenRow : '')}>
								<td className={classes.td} style={{ textAlign: 'left' }}>
									<div className={classes.label}>{label}</div>
									{subLabel && <div className={classes.subLabel}>{subLabel}</div>}
								</td>

								{values.map(({ diffIcon, diffClass, value }, i) => (
									<td
										key={i}
										className={clsx(classes.td, diffClass)}
										style={{ textAlign: 'right' }}
									>
										{diffIcon && diffIcon}
										<span className={classes.value}>{value}</span>
									</td>
								))}

								<td className={classes.td}>
									<Link
										to={`/reports/fuelForecast/${specialEventsPrefix}/${customer}/${region}`}
										className={classes.regionLink}
									>
										<div className={clsx(classes.value, classes.innerLink)}>
											View Details <LaunchIcon style={{ paddingLeft: 5, fontSize: 15 }} />
										</div>
									</Link>
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		);
	};

	drawChangeOverLastMonth = (p) => {
		const { dataForChart, refLineValue } = p;
		return (
			<ResponsiveContainer width="100%" height={350}>
				<BarChart data={dataForChart} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
					<defs>
						<linearGradient id="upColor" x1="0" y1="0" x2="0" y2="1">
							<stop offset="5%" stopColor="#81C784" stopOpacity={0.9} />
							<stop offset="95%" stopColor="#81C784" stopOpacity={0.1} />
						</linearGradient>
						<linearGradient id="downColor" x1="0" y1="0" x2="0" y2="1">
							<stop offset="5%" stopColor="#e57373" stopOpacity={0.1} />
							<stop offset="95%" stopColor="#e57373" stopOpacity={0.9} />
						</linearGradient>
					</defs>
					<XAxis dataKey="name" />
					<YAxis />
					<CartesianGrid strokeDasharray="3 3" />
					<Tooltip />
					<Legend verticalAlign="top" height={36} />
					<Bar
						type="monotone"
						name="% Change"
						dataKey="percentageChange"
						stroke="#4CAF50"
						fillOpacity={1}
					>
						{dataForChart.map((data, index) => {
							const isUp = data.percentageChange > 0;
							return (
								<Cell
									key={`cell-${index}`}
									fill={isUp ? 'url(#upColor)' : 'url(#downColor)'}
									stroke={isUp ? '#4CAF50' : '#f44336'}
								/>
							);
						})}
					</Bar>

					<ReferenceLine
						y={makePercentage(refLineValue)}
						stroke="#00BCD4"
						strokeDasharray="5 5"
						isFront={true}
						strokeWidth={3}
					/>
				</BarChart>
			</ResponsiveContainer>
		);
	};

	drawRebateComparison = (p) => {
		const { dataForChart } = p;
		return (
			<ResponsiveContainer width="100%" height={350}>
				<BarChart data={dataForChart} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
					<defs>
						<linearGradient id="upColorRebate" x1="0" y1="0" x2="0" y2="1">
							<stop offset="40%" stopColor={'#00ACC1'} stopOpacity={0.9} />
							<stop offset="100%" stopColor={'#81C784'} stopOpacity={0.9} />
						</linearGradient>
						<linearGradient id="downColorRebate" x1="0" y1="0" x2="0" y2="1">
							<stop offset="0%" stopColor={'#e57373'} stopOpacity={0.9} />
							<stop offset="60%" stopColor={'#00ACC1'} stopOpacity={0.9} />
						</linearGradient>

						<linearGradient id="upColorNoRebate" x1="0" y1="0" x2="0" y2="1">
							<stop offset="40%" stopColor={'#FDD835'} stopOpacity={0.9} />
							<stop offset="100%" stopColor={'#81C784'} stopOpacity={0.9} />
						</linearGradient>
						<linearGradient id="downColorNoRebate" x1="0" y1="0" x2="0" y2="1">
							<stop offset="0%" stopColor={'#e57373'} stopOpacity={0.9} />
							<stop offset="60%" stopColor={'#FDD835'} stopOpacity={0.9} />
						</linearGradient>

						<linearGradient id="upColorNoRebateGm" x1="0" y1="0" x2="0" y2="1">
							<stop offset="40%" stopColor={'#9935fd'} stopOpacity={0.9} />
							<stop offset="100%" stopColor={'#81C784'} stopOpacity={0.9} />
						</linearGradient>
						<linearGradient id="downColorNoRebateGm" x1="0" y1="0" x2="0" y2="1">
							<stop offset="0%" stopColor={'#e57373'} stopOpacity={0.9} />
							<stop offset="60%" stopColor={'#9935fd'} stopOpacity={0.9} />
						</linearGradient>
					</defs>
					<XAxis dataKey="name" />
					<YAxis />
					<CartesianGrid strokeDasharray="3 3" />
					<Tooltip />
					<Legend verticalAlign="top" height={76} layout="vertical" />
					<Bar
						name="In Rebate Program : % Change"
						dataKey="percentageChange"
						//stroke="#2196F3"
						stroke="#2196F3"
						strokeWidth={1}
						fill={'#00ACC1'}
						fillOpacity={1}
					>
						{dataForChart.map((data, index) => {
							const isUp = data.percentageChange > 0;
							return (
								<Cell
									key={`cell-${index}`}
									fill={isUp ? 'url(#upColorRebate)' : 'url(#downColorRebate)'}
									stroke={isUp ? '#4CAF50' : '#f44336'}
								/>
							);
						})}
					</Bar>

					<Bar
						name="Not Participating (Non G&M): % Change"
						dataKey="percentageChange2"
						stroke="#6D4C41"
						fill={'#FDD835'}
						strokeWidth={1}
						fillOpacity={1}
					>
						{dataForChart.map((data, index) => {
							const isUp = data.percentageChange2 > 0;
							return (
								<Cell
									key={`cell-${index}`}
									fill={isUp ? 'url(#upColorNoRebate)' : 'url(#downColorNoRebate)'}
									stroke={isUp ? '#4CAF50' : '#f44336'}
								/>
							);
						})}
					</Bar>

					<Bar
						name="Not Participating (GM) : % Change"
						dataKey="percentageChange3"
						stroke="#6D4C41"
						fill={'#9935fd'}
						strokeWidth={1}
						fillOpacity={1}
					>
						{dataForChart.map((data, index) => {
							const isUp = data.percentageChange3 > 0;
							return (
								<Cell
									key={`cell-${index}`}
									fill={isUp ? 'url(#upColorNoRebateGm)' : 'url(#downColorNoRebateGm)'}
									stroke={isUp ? '#4CAF50' : '#f44336'}
								/>
							);
						})}
					</Bar>
				</BarChart>
			</ResponsiveContainer>
		);
	};

	//- Third chart: the full best fit line on every day, so a finished month still shows the trend
	drawBestFitChart = (p) => {
		const { classes } = this.props;
		const {
			dataForChart,
			volumeBestFit,
			monthAverage,
			workingDate,
			totalGoodStations,
			totalStations,
		} = p;
		const { slope, startPoint, endPoint, r2, daysUsed, daysInMonth } = volumeBestFit;

		if (_.isEmpty(dataForChart)) {
			return null;
		}

		const firstDay = _.first(dataForChart);
		const lastDay = _.last(dataForChart);
		//- Same split the cards use (daysUsed = every day up to the working date)
		const firstPredictedDay = _.find(dataForChart, ({ dateKey }) => dateKey > workingDate);
		const daysPredicted = daysInMonth - daysUsed;
		const isFullMonth = daysPredicted <= 0;
		const lastMonthName = moment(workingDate).subtract(1, 'month').format('MMMM');
		const slopePointsPerDay = slope * 100;

		//- R2 is the share of the day to day swings the slope explains, not how close days sit to the line
		let fitDescription = 'not enough variation to measure';
		if (_.isFinite(r2)) {
			fitDescription = `the trend explains ${_.round(r2 * 100)}% of the daily swings`;
		}

		const bestFitStats = [
			{
				label: 'Line starts at',
				value: formatSignedPercentage(startPoint),
				subLabel: `on ${firstDay.name}`,
			},
			{
				label: 'Line ends at',
				value: formatSignedPercentage(endPoint),
				subLabel: `on ${lastDay.name}`,
			},
			{
				label: 'Slope',
				value: `${formatSigned(slopePointsPerDay, ' pts')} / day`,
				subLabel: `${formatSigned(
					slopePointsPerDay * (daysInMonth - 1),
					' pts',
					1
				)} across the month`,
			},
			{
				label: isFullMonth ? 'Month result (dashed line)' : 'Predicted month (dashed line)',
				value: formatSignedPercentage(monthAverage),
				subLabel: isFullMonth
					? `average of all ${daysInMonth} real days`
					: `average of ${daysUsed} real + ${daysPredicted} predicted days`,
			},
			{
				label: 'Days of real data',
				value: `${daysUsed} of ${daysInMonth}`,
				subLabel: isFullMonth
					? 'nothing left to predict'
					: `${daysPredicted} days read off the line`,
			},
			{
				label: 'Tanks counted',
				value: `${totalGoodStations} of ${totalStations}`,
				subLabel: 'the rest are in the Ignored Station Listing',
			},
			{
				label: 'Fit (R²)',
				value: _.isFinite(r2) ? _.round(r2, 2) : 'n/a',
				subLabel: fitDescription,
			},
		];

		const legendPayload = [
			{ value: 'Daily % change (faded = predicted day)', type: 'square', color: '#81C784' },
			{ value: 'Best fit line', type: 'line', color: '#FFCA28' },
			{ value: 'Month average', type: 'line', color: '#00BCD4' },
		];

		return (
			<div>
				<div className={classes.bestFitStats}>
					{bestFitStats.map(({ label, value, subLabel }) => {
						return (
							<div key={label} className={classes.bestFitStat}>
								<div className={classes.bestFitStatLabel}>{label}</div>
								<div className={classes.bestFitStatValue}>{value}</div>
								<div className={classes.bestFitStatSubLabel}>{subLabel}</div>
							</div>
						);
					})}
				</div>

				<ResponsiveContainer width="100%" height={340}>
					<ComposedChart data={dataForChart} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
						<defs>
							<linearGradient id="bestFitUp" x1="0" y1="0" x2="0" y2="1">
								<stop offset="5%" stopColor="#81C784" stopOpacity={0.9} />
								<stop offset="95%" stopColor="#81C784" stopOpacity={0.2} />
							</linearGradient>
							<linearGradient id="bestFitDown" x1="0" y1="0" x2="0" y2="1">
								<stop offset="5%" stopColor="#e57373" stopOpacity={0.2} />
								<stop offset="95%" stopColor="#e57373" stopOpacity={0.9} />
							</linearGradient>
							<linearGradient id="bestFitUpPredicted" x1="0" y1="0" x2="0" y2="1">
								<stop offset="5%" stopColor="#81C784" stopOpacity={0.3} />
								<stop offset="95%" stopColor="#81C784" stopOpacity={0.0} />
							</linearGradient>
							<linearGradient id="bestFitDownPredicted" x1="0" y1="0" x2="0" y2="1">
								<stop offset="5%" stopColor="#e57373" stopOpacity={0.0} />
								<stop offset="95%" stopColor="#e57373" stopOpacity={0.3} />
							</linearGradient>
						</defs>
						<XAxis dataKey="name" />
						<YAxis unit="%" />
						<CartesianGrid strokeDasharray="3 3" />
						<Tooltip
							content={(tooltipProps) =>
								this.renderBestFitTooltip({ ...tooltipProps, lastMonthName })
							}
						/>
						<Legend verticalAlign="top" height={36} payload={legendPayload} />

						{firstPredictedDay && (
							<ReferenceArea
								x1={firstPredictedDay.name}
								fill="#9E9E9E"
								fillOpacity={0.08}
								label={{ value: 'Predicted from the line', position: 'insideTop', fill: '#999' }}
							/>
						)}

						<ReferenceLine y={0} stroke="#999" />

						<Bar name="Daily % change" dataKey="percentageChange">
							{dataForChart.map((data, index) => {
								const { isPrediction, percentageChange } = data;
								const isUp = percentageChange > 0;

								let fill, stroke;
								if (isPrediction) {
									fill = isUp ? 'url(#bestFitUpPredicted)' : 'url(#bestFitDownPredicted)';
									stroke = isUp ? 'rgba(76,175,80 ,.3)' : 'rgba(244,67,54 ,.3)';
								} else {
									fill = isUp ? 'url(#bestFitUp)' : 'url(#bestFitDown)';
									stroke = isUp ? '#4CAF50' : '#f44336';
								}

								return <Cell key={`bestFitCell-${index}`} fill={fill} stroke={stroke} />;
							})}
						</Bar>

						<Line
							name="Best fit line"
							dataKey="bestFitPoint"
							stroke="#FFCA28"
							strokeWidth={3}
							dot={false}
							activeDot={{ r: 4 }}
						/>

						{_.isFinite(monthAverage) && (
							<ReferenceLine
								y={makePercentage(monthAverage)}
								stroke="#00BCD4"
								strokeDasharray="5 5"
								isFront={true}
								strokeWidth={2}
							/>
						)}
					</ComposedChart>
				</ResponsiveContainer>

				<div className={classes.bestFitExplain}>
					<div>
						<b>Bars:</b> each day&apos;s total gallons from the {totalGoodStations} counted tanks,
						divided by what those same tanks averaged on that weekday in {lastMonthName}. Hover a
						bar to see the gallons behind it.
					</div>
					<div>
						<b>Yellow line:</b> the straight line that sits closest to all the real days (linear
						regression). It always passes through the average of the real days, so one unusual day
						only nudges it.
					</div>
					<div>
						<b>Faded bars:</b> days that haven&apos;t happened yet. Their values are read straight
						off the line.
					</div>
					<div>
						<b>Dashed line:</b> the average of every bar in the month. This is the &quot;Predicted
						percentage change&quot; at the top of the page, and once the month is over it is the
						actual result.
					</div>
				</div>
			</div>
		);
	};

	renderBestFitTooltip = ({ active, payload, lastMonthName }) => {
		const { classes } = this.props;
		const { includeSpecialEvents } = this.state;
		if (!active || _.isEmpty(payload)) {
			return null;
		}

		const {
			dateKey,
			percentageChange,
			bestFitPoint,
			isPrediction,
			workingTotalVolume,
			lastMonthTotalAvgVolumeOnThisDow,
		} = payload[0].payload;
		const dayMoment = moment(dateKey);
		const dayName = dayMoment.format('dddd');
		const specialEventName = SPECIAL_EVENTS[dateKey];
		const isSmoothedHoliday = specialEventName && !includeSpecialEvents;
		const gapFromLine =
			_.isFinite(percentageChange) && _.isFinite(bestFitPoint)
				? percentageChange - bestFitPoint
				: null;

		return (
			<div className={classes.bestFitTooltip}>
				<div className={classes.bestFitTooltipTitle}>
					{dayMoment.format('dddd M/D')}
					{isPrediction ? ' (predicted)' : ''}
				</div>

				{specialEventName && (
					<div className={classes.bestFitTooltipNote}>
						{specialEventName}
						{isSmoothedHoliday ? ` : counted as ${lastMonthName}'s average` : ''}
					</div>
				)}

				{isPrediction && (
					<div className={classes.bestFitTooltipNote}>
						No sales yet, so the bar is read off the best fit line.
					</div>
				)}

				{!isPrediction && (
					<React.Fragment>
						<div>
							{isSmoothedHoliday ? 'Counted as' : 'Sold'}: {formatGallons(workingTotalVolume)}
						</div>
						<div>
							{lastMonthName} avg for a {dayName}: {formatGallons(lastMonthTotalAvgVolumeOnThisDow)}
						</div>
						<div>
							Daily change: <b>{formatSigned(percentageChange, '%')}</b>
						</div>
					</React.Fragment>
				)}

				<div style={{ color: '#F9A825' }}>
					Best fit line: <b>{formatSigned(bestFitPoint, '%')}</b>
				</div>

				{!isPrediction && _.isFinite(gapFromLine) && (
					<div className={classes.bestFitTooltipNote}>
						{formatSigned(gapFromLine, ' pts')} {gapFromLine >= 0 ? 'above' : 'below'} the line
					</div>
				)}
			</div>
		);
	};

	getUpDown = (diff) => {
		const { classes } = this.props;
		let diffIcon, diffClass;

		if (diff > 1) {
			diffIcon = <UpIcon className={classes.upDownIcon} />;
			diffClass = classes.diffUp;
		} else if (diff < 1) {
			diffIcon = <DownIcon className={classes.upDownIcon} />;
			diffClass = classes.diffDown;
		}
		return { diffClass, diffIcon };
	};

	renderStationTreeMap = ({ stationTankStats }) => {
		//const { classes } = this.props;
		if (!stationTankStats) {
			return;
		}

		const diffDataForTreeMap = [];
		_.sortBy(stationTankStats, 'totalVolumePercentageChangeOverLastMonth').forEach(
			(stationTankResult) => {
				//stationTankStats.forEach(stationTankResult => {
				const {
					station,
					isInvalid,
					totalVolumeThisMonth,
					totalVolumeLastMonth,
					totalVolumePercentageChangeOverLastMonth,
				} = stationTankResult;
				if (isInvalid) {
					return null;
				}
				const diff = _.round(totalVolumeThisMonth - totalVolumeLastMonth);
				diffDataForTreeMap.push({
					name: station.number,
					children: [
						{
							name: station.number,
							size: Math.abs(diff),
							diff,
							totalVolumePercentageChangeOverLastMonth,
						},
					],
				});
			}
		);

		return (
			<div>
				<ResponsiveContainer width="100%" height={700}>
					<Treemap
						data={diffDataForTreeMap}
						dataKey="size"
						ratio={4 / 3}
						stroke="#fff"
						fill="#8884d8"
						content={<CustomizedTreeMapContent />}
					/>
				</ResponsiveContainer>
			</div>
		);
	};

	renderStationBreakdown = ({ stationTankStats }) => {
		const { classes } = this.props;

		if (!stationTankStats) {
			return;
		}

		const firstStation = _.first(stationTankStats);
		if (!firstStation) {
			return;
		}

		const { changeByDate } = firstStation;
		const dateColumns = [];

		_.keys(changeByDate)
			.sort()
			.forEach((date) => {
				dateColumns.push(moment(date).format('M/D'));
			});

		let oddCount = 0;

		const params = {
			accessToken: this.props.accessToken,
			stationIdAndTankNumbers: [],
		};

		stationTankStats.forEach((stationTankStat) => {
			const { station, tankNumber } = stationTankStat;
			params.stationIdAndTankNumbers.push(`${station.stationId}_${tankNumber}`);
		});

		const request = {
			method: 'report.forecast.download',
			params,
		};
		const downloadUrl = `/api?request=${JSON.stringify(request)}`;

		return (
			<Grid item xs={12} md={8}>
				<a
					href={downloadUrl}
					style={{ display: 'block', margin: '30px 0px', textDecoration: 'none' }}
				>
					<Button variant="outlined" color="primary">
						<span className={classes.downloadCsvIcon} /> Download CSV of Station Breakdown
					</Button>
				</a>

				<table className={classes.stationBreakdownTable}>
					<thead>
						<tr>
							<td className={classes.colLabel}>Station</td>
							<td
								className={classes.colLabel}
								style={{ alignRight: 'right', borderRight: '1px solid #666' }}
							>
								Vol %
							</td>
							<td
								className={classes.colLabel}
								style={{ alignRight: 'right', borderRight: '1px solid #666' }}
							>
								Mean
							</td>

							{dateColumns.map((date) => (
								<td className={classes.colLabel} style={{ alignRight: 'right' }} key={date}>
									{date}
								</td>
							))}

							{/*
						<td>
							<div className={classes.colLabel}>Details</div>
						</td>
						*/}
						</tr>
					</thead>
					<tbody>
						{_.sortBy(stationTankStats, 'totalVolumePercentageChangeOverLastMonth').map(
							(stationTankResult, i) => {
								const {
									station,
									tankNumber,
									changeByDate,
									isInvalid,
									totalVolumePercentageChangeOverLastMonth,
									meanPercentageChangeOverLastMonth,
								} = stationTankResult;
								if (isInvalid) {
									return null;
								}
								const isOdd = oddCount++ % 2;

								const mPercentage = formatPercentage(meanPercentageChangeOverLastMonth, 0);
								const mRgb = pToC(meanPercentageChangeOverLastMonth);

								const vPercentage = formatPercentage(totalVolumePercentageChangeOverLastMonth, 0);
								const vRgb = pToC(totalVolumePercentageChangeOverLastMonth);

								return (
									<tr
										key={`stbd_${i}`}
										className={clsx(classes.row, !isOdd ? classes.evenRow : '')}
									>
										<td className={classes.stationNameCell} style={{ textAlign: 'left' }}>
											<div className={classes.label}>
												{station.number} - {station.name}
												<span style={{ fontSize: 12, color: '#666' }}> tank {tankNumber}</span>
											</div>
										</td>

										<td
											className={clsx(classes.stationPercentageCell)}
											style={{
												textAlign: 'right',
												backgroundColor: vRgb,
												borderRight: '1px solid #666',
											}}
										>
											{vPercentage}
										</td>

										<td
											className={clsx(classes.stationPercentageCell)}
											style={{
												textAlign: 'right',
												backgroundColor: mRgb,
												borderRight: '1px solid #666',
											}}
										>
											{mPercentage}
										</td>

										{_.values(changeByDate).map(({ percentageChangeOverLastMonth }, i) => {
											const p = formatPercentage(percentageChangeOverLastMonth, 0);
											const rgb = pToC(percentageChangeOverLastMonth);

											return (
												<td
													key={i}
													className={clsx(classes.stationPercentageCell)}
													style={{ textAlign: 'right', backgroundColor: rgb }}
												>
													{p}
												</td>
											);
										})}

										{/*
								<td className={classes.std}>
									<Link to={`/reports/fuelForecastForStation`} className={classes.regionLink}>
										<div className={clsx(classes.value, classes.innerLink)}>
											View Details <LaunchIcon style={{paddingLeft : 5, fontSize : 15}}/>
										</div>
									</Link>
								</td>
								*/}
									</tr>
								);
							}
						)}
					</tbody>
				</table>
			</Grid>
		);
	};

	renderSkippedStations = ({ stationTankStats }) => {
		const { classes } = this.props;
		if (!stationTankStats) {
			return;
		}

		let oddCount = 0;
		return (
			<Grid item xs={12} md={12}>
				<table className={classes.stationBreakdownTable}>
					<thead>
						<tr>
							<td className={classes.colLabel}>Station</td>
							<td className={classes.colLabel}>Reasons</td>
						</tr>
					</thead>
					<tbody>
						{stationTankStats.map((stationTankResult, i) => {
							const {
								station,
								tankNumber,
								isInvalid,
								invalidReasons,
								anomalies,
							} = stationTankResult;
							if (!isInvalid) {
								return null;
							}
							const isOdd = oddCount++ % 2;

							return (
								<tr key={i} className={clsx(classes.row, !isOdd ? classes.evenRow : '')}>
									<td className={classes.stationNameCell} style={{ textAlign: 'left' }}>
										<div className={classes.label}>
											{station.number} - {station.name}
											<span style={{ fontSize: 12, color: '#666' }}> tank {tankNumber}</span>
										</div>
									</td>

									<td className={classes.stationReasonCell} style={{ textAlign: 'left' }}>
										<div className={classes.label}>
											{invalidReasons.map((reason, k) => {
												return <div key={k}>{reason}</div>;
											})}

											{anomalies.map((anomaly, j) => {
												return <div key={`anom_${j}`}>Anomaly Ignored : {anomaly}</div>;
											})}
										</div>
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</Grid>
		);
	};

	renderHowCalculated = () => {
		const { classes, slidingMonthComparisonResult } = this.props;
		const { regionFromUrl, customerFromUrl } = this.state;
		let {
			meanPercentageChangeOverLastMonth,
			meanPercentageChangeOverLastMonthWithStdRemoved,
			finalPrediction,
			finalPredictionWithStdRemoved,
			programStats,
			customerStats,
		} = slidingMonthComparisonResult;

		if (customerFromUrl) {
			// This COULD be rebate program
			let stats = undefined;
			const rebateStats = _.find(programStats, { program: regionFromUrl });

			if (rebateStats) {
				stats = rebateStats;
			} else {
				const customerStat = _.find(customerStats, { customer: customerFromUrl });
				if (!customerStat) {
					return <div>Missing key ({customerFromUrl}) in stat list. Check the URL?</div>;
				}

				if (!regionFromUrl) {
					return <div>Missing region in URL. Check the URL?</div>;
				}
				const regionStats = _.find(customerStat.regions, { region: regionFromUrl });
				if (!regionStats) {
					return (
						<div>
							Missing region ({regionFromUrl}) in list for customer: {customerFromUrl}. Check the
							URL?
						</div>
					);
				}
				stats = regionStats;
			}

			({
				meanPercentageChangeOverLastMonth,
				meanPercentageChangeOverLastMonthWithStdRemoved,
				finalPrediction,
				finalPredictionWithStdRemoved,
			} = stats);
		}

		const stationStats = [
			{
				label: `Average station change over last month`,
				value: formatPercentage(meanPercentageChangeOverLastMonth),
				...this.getUpDown(meanPercentageChangeOverLastMonth),
			},
			{
				label: `Average station change over last month`,
				subLabel: '(outliers removed)',
				value: formatPercentage(meanPercentageChangeOverLastMonthWithStdRemoved),
				...this.getUpDown(meanPercentageChangeOverLastMonthWithStdRemoved),
			},
			{
				label: `Predicted average station change over last month`,
				value: formatPercentage(finalPrediction),
				...this.getUpDown(finalPrediction),
			},
			{
				label: `Predicted average station change over last month`,
				value: formatPercentage(finalPredictionWithStdRemoved),
				...this.getUpDown(finalPredictionWithStdRemoved),
				subLabel: '(outliers removed)',
			},
		];

		return (
			<div className={classes.analysisContainer}>
				<Accordion
				//onChange={this.props.onChange}
				//expanded={expanded}
				>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel1a-content"
						id="panel1a-header"
					>
						<div className={classes.howCalculated}>
							<InfoIcon style={{ paddingRight: 5 }} /> Station % / How this is calculated
						</div>
					</AccordionSummary>
					<AccordionDetails>
						<div>
							<table className={classes.statTable} style={{ width: 'auto' }}>
								<tbody>{this.drawOverallStats({ overallStats: stationStats })}</tbody>
							</table>
							<div className={classes.analysisTitle}>Station Filtering</div>
							Some our data can be sporadic so we filter down to a subset of stations that have at
							least 85% of their sales reported and valid in the last 2 months, and 100% of their
							sales reported and valid in the current month.
							<br />
							<br />
							When checking days sales outliers are flagged if the volume for the day is above 250%
							or below 15% when compared to the average for that day of the week from the last 3
							months. These are flagged as this spike in usually caused by data entry error or flash
							sales which should not be taken into account when analyzing trends.
							<div className={classes.analysisTitle}>How the Percentage Change is Calculated</div>
							For the current month, the FMP goes through each station individually and compares the
							volume from each day of the current month with the average volume from the previous
							month for that day of the week.
							<br />
							<br />
							Note : This method of comparing day of the week to previous day of the week averages
							is more accurate than comparing to averages because the day of the week heavily
							influences how much fuel is sold at stations. This allows us to get a more accurate
							comparison early in the month because we are comparing a Monday to an average Monday
							instead of comparing a Monday to an entire monthly average.
							<br />
							<br />
							After the percentage change for each station for every day is calculated then the
							system calculates the mean for that day and produces the average percentages change
							over last month for that day and that is what is shown in the graph.
							<div className={classes.analysisTitle}>Two Sets of Data : Outliers Removed</div>
							There two sets of data that is calculated. The difference is the one that says
							outliers are removed means, that on each day of the month all the averages for that
							day across all stations are analyzed and any data points that fall outside 3 standard
							deviations is not used to calculated the overall percentage. The goal here is to
							remove stations that might have a high or low percentage change due to a data error or
							sale and remove that from grossly over effecting the average. I have both sets of data
							because some of these percentages are true and should be considered. Eventually we
							might choose which data set we want but including both for now.
							<div className={classes.analysisTitle}>Predictions</div>
							The prediction is calculated by taking all the data points that we have for the month
							and fitting those data points to the best trend line via linear regression and
							creating a model for the rest of the month. Each data of the month is fed into the
							model and then the system takes all existing averages for the month, and all predicted
							values for the month and averages them to get an overall final prediction of where we
							will be for the current month compared to the last month.
							<br />
							<br />
							Note : The prediction model should not be relied on until at least the 10th of the
							month because it does not have enough data points to predict an average trend line.
						</div>
					</AccordionDetails>
				</Accordion>
			</div>
		);
	};
}

FuelForecast.propTypes = {
	classes: PropTypes.object.isRequired,
	getSlidingMonthComparison: PropTypes.func.isRequired,
	slidingMonthComparisonResult: PropTypes.object,

	authUser: PropTypes.object,
	match: PropTypes.object,
	location: PropTypes.object,
	accessToken: PropTypes.string,
};

export default _.flow([withStyles(styles), ReportsMonitoringContainer, withRouter])(FuelForecast);
